import { render, staticRenderFns } from "./OpinionOtherUserListTab.vue?vue&type=template&id=1898de37&scoped=true&lang=pug"
import script from "./OpinionOtherUserListTab.vue?vue&type=script&lang=ts"
export * from "./OpinionOtherUserListTab.vue?vue&type=script&lang=ts"
import style0 from "./OpinionOtherUserListTab.vue?vue&type=style&index=0&id=1898de37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1898de37",
  null
  
)

export default component.exports